import axios from 'axios'

import Cookies from 'js-cookie'
import { getToken, setToken, clearToken } from './tokens'
import store from './store'
import pageStore from '../page/store'
import { fetchPage } from '../page/actions';

export var login = (creds) => {
  const dataLayer = window.dataLayer || { push: _ => {} }
  var payload = axios({
    method: 'POST',
    url: `${window.settings.apiBaseUrl}/identity/signin`,
    params: {
      site: window.settings.internalName
    },
    data: creds,
    headers: {
      'x-api-key': window.settings.baseAPIKey
    },
  }).then( res => {
    dataLayer.push({
      'event': 'avod_finish_signin',
    });
    setToken(res.data)
    pageStore.dispatch(fetchPage(window.location.pathname, null, null, res.data.userId));
    return res.data
  })
  return { type: 'LOGIN', payload: payload }
}


export var fbLogin = (user) => {
  let utmCookie = Cookies.get('utm')
  let utmData = utmCookie && JSON.parse(utmCookie)
  const dataLayer = window.dataLayer || { push: _ => {} }
   
  var loginParams = {
    site: window.settings.internalName,
    campaign: utmData && utmData.utm_campaign,
    campaign_source: utmData && utmData.utm_source,
    campaign_medium: utmData && utmData.utm_medium,
    utm_params: utmData && utmData.utm_params
  }

  var payload = axios({
    method: 'POST',
    url: `${window.settings.apiBaseUrl}/identity/signin/facebook`,
    params: loginParams,
    headers: {
      'x-api-key': window.settings.baseAPIKey
    },
    data: {
      facebookToken: user.facebookToken,
      emailConsent: user.emailConsent
    }
  }).then( res => {
    dataLayer.push({
      'event': 'avod_finish_registration',
      'registration_method': 'facebook'
    });
    setToken(res.data)
    return res.data
  })

  return { type: 'LOGIN', payload: payload }
}

export var googleLogin = (user) => {
  let utmCookie = Cookies.get('utm')
  let utmData = utmCookie && JSON.parse(utmCookie)
  const dataLayer = window.dataLayer || { push: _ => {} }

  var loginParams = {
    site: window.settings.internalName,
    device: 'web_browser',
    campaign: utmData && utmData.utm_campaign,
    campaign_source: utmData && utmData.utm_source,
    campaign_medium: utmData && utmData.utm_medium,
    utm_params: utmData && utmData.utm_params
  }

  var payload = axios({
    method: 'POST',
    url: `${window.settings.apiBaseUrl}/identity/signin/google`,
    params: loginParams,
    data: {
      googleToken: user.googleToken,
      emailConsent: user.emailConsent
    },
    headers: {
      'x-api-key': window.settings.baseAPIKey
    }
  }).then( res => {
    dataLayer.push({
      'event': 'avod_finish_registration',
      'registration_method': 'google'
    });
    setToken(res.data)
    return res.data
  })

  return { type: 'LOGIN', payload: payload }
}

export var logout = () => {
  var payload =
    getToken().then(token => {
      return axios({
        method: 'POST',
        url: `${window.settings.apiBaseUrl}/identity/signout`,
        params: { site: window.settings.internalName },
        headers: { 
          Authorization: token,
          'x-api-key': window.settings.baseAPIKey
        }
      }).then( res => {
        clearToken()
        Cookies.remove('vl-user');
        window.localStorage.removeItem('user')
        pageStore.dispatch(fetchPage(window.location.pathname));
        return res.data
      }).catch(e => {
        clearToken()
        console.error(e)
      })
    })

  return { type: 'LOGOUT', payload: payload }
}

export var signup = (user) => {
  let utmCookie = Cookies.get('utm')
  let utmData = utmCookie && JSON.parse(utmCookie)
  const dataLayer = window.dataLayer || { push: _ => {} }

  var signupParams = {
    site: window.settings.internalName,
    campaign: utmData && utmData.utm_campaign,
    campaign_source: utmData && utmData.utm_source,
    campaign_medium: utmData && utmData.utm_medium,
    utm_params: utmData && utmData.utm_params
  }

  var promise = axios({
    method: 'POST',
    url: `${window.settings.apiBaseUrl}/identity/signup`,
    params: signupParams,
    data: user,
    headers: {
      'x-api-key': window.settings.baseAPIKey
    }
  }).then( res => {
    dataLayer.push({
      'event': 'avod_finish_registration',
      'registration_method': 'viewlift'
    });
    setToken(res.data)
    return res.data
  })
  return { type: 'SIGNUP', payload: promise }
}

export var update = (data) => {
  
  var promise = getToken().then(token => {
    return axios({
      url: '/identity/user',
      baseURL: window.settings.apiBaseUrl,
      method: 'POST',
      params: {
        site: window.settings.internalName
      },
      headers: {
        'Authorization': token,
        'x-api-key': window.settings.baseAPIKey
      },
      data: JSON.stringify(data),
      contentType: 'application/json'
    }).then( res => {
      setToken(res.data)
      return res
    })
  })
  return { type: 'UPDATE', payload: promise }
}

export var refresh = () => {
  var promise = getToken().then(token => {
    return axios({
      url: 'identity/user',
      baseURL: window.settings.apiBaseUrl,
      method: 'GET',
      params: {
        site: window.settings.internalName
      },
      headers: { 
        'Authorization': token,
        'x-api-key': window.settings.baseAPIKey 
      }
    })
  })
  return { type: 'REFRESH', payload: promise }
}

export var subscribe = (o) => {
  const payload = getToken().then(token => {
    const user = store.getState().user
    const amazonPay = o.paymentUniqueId
    const paypal = o.vlTransactionId
    const stripe = o.billingToken
    const data = {
      subscription: o.subscription || 'stripe',
      siteId: window.settings.siteId,
      platform: 'web_browser',
      planId: o.plan.id,
      planIdentifier: o.plan.identifier,
      userId: user.userId,
      currencyCode: o.plan.planDetails[0].recurringPaymentCurrencyCode,
      appliedOffers: o.offerCode ? [ o.offerCode ] : undefined,
      ...(paypal && { vlTransactionId: o.vlTransactionId }),
      ...(amazonPay && { paymentUniqueId: o.paymentUniqueId }),
      ...(stripe && {
        stripeToken: o.billingToken.stripeToken.id || o.billingToken.stripeToken.card.id,
        requestId: o.billingToken.requestId || o.billingToken.stripeToken.card.requestId,
      }),
    }

    return axios({
      method: 'POST',
      url: `${window.settings.apiBaseUrl}/subscription/subscribe`,
      params: { platform: 'web_browser', site: window.settings.internalName },
      headers: { 
        Authorization: token,
        'x-api-key': window.settings.baseAPIKey
      },
      data: data
    })
  })
  return { type: 'CREATE_SUBSCRIPTION', payload: payload }
}

export var getCardInfo = (user) => {
  var payload = getToken().then(token => {
    return axios({
      method: 'GET',
      url: `${window.settings.apiBaseUrl}/payments/billing-history/last4`,
      params: {
        userId: user.userId,
        site: window.settings.internalName
      },
      headers: {
        'Authorization': token,
        'x-api-key': window.settings.baseAPIKey
      }
    }).then(res =>{
      return res.data
    })
  })

  return { type: "UPDATE_CARD", payload: payload };
}

export var transaction = (data) => {
  return  getToken().then(token => {
    return axios({
      method: 'POST',
      url: `${window.settings.apiBaseUrl}/transaction/transaction`,
      headers: {
        Authorization: token,
        'x-api-key': window.settings.baseAPIKey
      },
      data: JSON.stringify(data)
    })
  })
}


export var getMySubscription = (cb) => {
  var payload = getToken().then( (token, refreshToken) => {
    var userId = store.getState().user.userId
    return axios({
      method: 'GET',
      url: `${ window.settings.apiBaseUrl }/subscription/user`,
      params: { site: window.settings.internalName, userId: userId },
      headers: { 
        Authorization: token,   
        'x-api-key': window.settings.baseAPIKey 
      }
    }).then( res => {
      if (cb) cb()
      return res.data
    })
  })
  return { type: 'GET_SUBSCRIPTION', payload: payload}
}

export var subscribeMercado = (o) => {
  var user = store.getState().user;
  var data = {
    email: o.email,
    mercadopagoToken: o.id,
    firstSixDigits: o.firstSixDigits,
    subscription: 'mercadopago',
    siteId: window.settings.siteId,
    platform: 'web_browser',
    planId: o.plan.id,
    planIdentifier: o.plan.identifier,
    userId: user.userId,
    currencyCode: o.plan.planDetails[0].recurringPaymentCurrencyCode,
    appliedOffers: o.offerCode ? [ o.offerCode ] : undefined,
    issuerId: o.issuerId,
    paymentMethodId: o.paymentMethodId
  }
  var payload = getToken()
  .then((token) => {
    return axios({
      method: 'POST',
      url: `${window.settings.apiBaseUrl}/subscription/subscribe`,
      params: { site: window.settings.internalName, platform: 'web_browser' },
      headers: { 
        Authorization: token,
        'x-api-key': window.settings.baseAPIKey
      },
      data: data
    })
  })
  .catch(err=>{
    console.log(err);
  })
  return { type: 'CREATE_SUBSCRIPTION', payload: payload }
}


export const tveSignin = (user) => {
  axios({
    method: 'POST',
    url: `${window.settings.apiBaseUrl}/identity/signin/tve`,
    params: { site: window.settings.internalName, platform: 'web_browser' },
    headers: { 
      'x-api-key': window.settings.baseAPIKey
    },
    data: user
  })
}